import { apiClient } from '@/shared/lib/axios';
import { getApiErrorMessage } from '@/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate, useParams } from 'react-router-dom';
import useAppToast from '../useAppToast';
import type { InsurerAttentionAttachmentSlot } from './useAdminInsurerAttentionAttachmentUpload';

export interface InsurerAttentionStorePayload {
  prefecture_id: string;
  publish_date: string;
  remarks: string;
  insurer_ids: number[];
  attachments?: (InsurerAttentionAttachmentSlot | null)[];
}

export const useAdminInsurerAttentionStore = () => {
  const { site } = useParams<{ site: string }>();
  const siteType = site ?? 'medix';
  const toast = useAppToast();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: (payload: InsurerAttentionStorePayload) =>
      apiClient.post(`/admin/${siteType}/insurer-attentions`, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-insurer-attentions', siteType] });
      toast.success('更新しました。');
      navigate(`/${siteType}/admin/insurer_attentions`);
    },
    onError: err => {
      toast.error(getApiErrorMessage(err, '一括登録に失敗しました。'));
    },
  });
};
